export default "__VITE_ASSET__DBTuuT7k__"